import {z} from 'zod';
import catalog from '../config/google-services.json' with {type: 'json'};

export const GoogleServiceSchema = z.enum(Object.keys(catalog) as [keyof typeof catalog, ...Array<keyof typeof catalog>]);
export type GoogleService = z.infer<typeof GoogleServiceSchema>;
export const GoogleServices = Object.entries(catalog).map(([id, service]) => ({id: GoogleServiceSchema.parse(id), ...service}));
export const GoogleStatusSchema = z.object({
  connected: z.boolean(), email: z.email().nullable(), signInLinked: z.boolean(),
  services: z.array(GoogleServiceSchema), updatedAt: z.iso.datetime().nullable()
}).strict();
export type GoogleStatus = z.infer<typeof GoogleStatusSchema>;
export const GoogleConfigurationSchema = z.object({clientSecretFile: z.string().regex(/^\/[A-Za-z0-9_./-]+$/)}).strict();
export const GOOGLE_CALLBACK_PATH = '/api/account/google/callback';
export const GOOGLE_ERROR_FRAGMENT = 'google-error';
export const GoogleCallbackErrorSchema = z.object({
  name: z.string(), message: z.string(), stack: z.string().optional(), cause: z.unknown().optional(),
  errors: z.array(z.unknown()).optional(), status: z.number().int().min(400).max(599)
}).strict();
